export const initGA4 = () => {
  // Prevent duplicate script injection
  if (document.getElementById('ga4-script')) return;

  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-M8V4N5RMKC';
  script1.id = 'ga4-script';

  const script2 = document.createElement('script');
  script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-S59X8DVXKB');
    `;

  document.head.appendChild(script1);
  document.head.appendChild(script2);
};
